import { useState, useRef, useEffect } from 'react';
import { ListPill, TagPill } from './CustomerTable';

interface TruncatedItemsProps {
  items: Array<{ id: string; name: string }>;
  maxVisible?: number;
  type: 'list' | 'tag';
  customerName?: string;
}

export const CustomerTableTruncatedItems = ({ items, maxVisible = 1, type, customerName }: TruncatedItemsProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const visibleItems = items.slice(0, maxVisible);
  const remainingCount = items.length - maxVisible;

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (remainingCount > 0) {
      const rect = e.currentTarget.getBoundingClientRect();
      const tooltipWidth = 250; // Approximate tooltip width
      const offsetX = Math.max(0, rect.left - (tooltipWidth / 2) + (rect.width / 2));
      
      setTooltipPosition({
        x: offsetX,
        y: rect.bottom + 8,
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip]);

  const renderItem = (item: { id: string; name: string }) => {
    if (type === 'list') {
      return <ListPill key={item.id} name={item.name} />;
    } else {
      return <TagPill key={item.id} name={item.name} />;
    }
  };

    return (
    <div className="relative">
      <div className="flex gap-2 flex-wrap items-center">
        {visibleItems.map(renderItem)}
        {remainingCount > 0 && (
          <div
            ref={triggerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="cursor-pointer"
          >
                         <span className="bg-[#F1F9FF] py-1 px-2 text-xs text-[#1E4A8B] inline-flex items-center rounded-md">
               +{remainingCount}
             </span>
          </div>
        )}
      </div>

                           {/* Tooltip */}
         {showTooltip && remainingCount > 0 && (
                       <div
              ref={tooltipRef}
              className="fixed z-[9999] bg-white border border-gray-200 rounded-lg shadow-lg p-3 min-w-[200px] max-w-[300px]"
             style={{
               left: `${tooltipPosition.x}px`,
               top: `${tooltipPosition.y}px`,
             }}
             onMouseEnter={() => setShowTooltip(true)}
             onMouseLeave={handleMouseLeave}
           >
           <div className="font-semibold text-sm mb-2 text-gray-800">
             {customerName}
           </div>
           <div className="space-y-1">
             {items.slice(maxVisible).slice(0, 4).map((item) => (
               <div key={item.id} className="text-sm text-gray-700 bg-gray-100 py-1 px-2 rounded">
                 {item.name}
               </div>
             ))}
           </div>
           {items.length > maxVisible + 4 && (
             <div className="text-brand-baseBlue text-xs mt-2 cursor-pointer">
               and {items.length - maxVisible - 4} more...
             </div>
           )}
         </div>
       )}
    </div>
  );
};
